<template>
    <VuePerfectScrollbar style="height: calc(100dvh - 4rem); background-color: #f5f5f5" :settings="{ suppressScrollX: true }">
        <div>
            <div class="d-flex flex-column align-items-center" style="margin-top: 2.6rem">
                <img src="/logo/iRender-fulltext.svg" style="height: 2rem" alt="" />
                <div style=" color: #1967d2; font-size: 1.5rem; margin-top: 0.5rem; text-shadow: 2px 2px #ffffff; ">
                    {{ $t('support.title') }}
                </div>
            </div>

            <div class="">
                <div class="d-flex flex-column flex-lg-row m-auto justify-content-center">
                    <div class="d-flex flex-column align-items-center justify-content-center mt-5 mb-5">
                        <div>
                            <el-card class="box-card mb-5" style="max-width: 95vw;">
                                <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <img src="/background/support/support-background-1.svg" style="height: 17.5rem"
                                            alt="" />
                                    </div>
                                    <div class="d-flex flex-column flex-fill align-items-center"
                                        style="margin-left: 1rem">
                                        <div class="d-flex justify-content-center"
                                            style="font-size: 1.2rem; color: #42a5f5">
                                            {{ $t('support.liveSupport') }}
                                        </div>
                                        <div
                                            class="box-time-notification d-flex flex-row justify-content-center align-items-center flex-fill mt-5">
                                            <div class=" d-flex flex-column justify-content-center align-items-end mr-2 "
                                                style="color: #9e9e9e; font-size: 0.85rem">
                                                <!-- <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    Monday to Friday
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    Saturday & Sunday
                                                </div> -->
                                                <div class="box-time-zone-mobile d-flex align-items-center" style="height: 1.75rem"></div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center ml-2"
                                                style="font-size: 0.85rem">
                                                <!-- <div class="d-flex align-items-center" style="height: 1.75rem; color: #409EFF;">
                                                    24/7
                                                </div> -->
                                                <div class="d-flex align-items-center" style="height: 1.75rem; color: #409EFF;">
                                                    {{ $t('support.liveSupportHours') }} <span class="box-time-zone">{{ $t('support.timezoneLabel') }}</span>
                                                </div>
                                                <div class="box-time-zone-mobile d-flex align-items-center" style="height: 1.75rem; color: #409EFF;">
                                                    {{ $t('support.timesShownUtc7') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class=" d-flex flex-row justify-content-center align-items-center flex-fill mt-5 ">
                                            <div class=" d-flex flex-column justify-content-center align-items-end mr-2 "
                                                style="color: #9e9e9e; font-size: 0.85rem">
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    {{ $t('support.skypeSupport') }}
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    {{ $t('support.quickChat') }}
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center ml-2"
                                                style="font-size: 0.85rem">
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-link href="https://join.skype.com/invite/qo5nEkWfKgyF"
                                                        target="_blank" :underline="false">iRender Support</el-link>
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-button @click="openTawkTo()" type="text">{{ $t('support.chatNow') }}</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                            <el-card class="box-card" style="max-width: 95vw;">
                                <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                                    <div class="d-flex flex-column flex-fill align-items-center"
                                        style="margin-left: 1rem">
                                        <div class="d-flex justify-content-center"
                                            style="font-size: 1.2rem; color: #42a5f5">
                                            {{ $t('support.receiveComplaints') }}
                                        </div>
                                        <div
                                            class=" d-flex flex-row justify-content-center align-items-center flex-fill mt-5 ">
                                            <div class=" d-flex flex-column justify-content-center align-items-end mr-2 "
                                                style="color: #9e9e9e; font-size: 0.85rem">
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    {{ $t('support.emailLabel') }}
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    Whatsapp
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    Skype
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    Zalo
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center ml-2"
                                                style="font-size: 0.85rem">
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-link :href="`mailto:${EMAIL_SUPPORT}`" target="_blank"
                                                        :underline="false">{{EMAIL_SUPPORT}}</el-link>
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-link
                                                        :href="`whatsapp://send?phone=+84912785500&text=Hello%2C%20World!`"
                                                        target="_blank" :underline="false">+(84) 912-785-500</el-link>
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-link href="https://join.skype.com/invite/qo5nEkWfKgyF"
                                                        target="_blank" :underline="false">iRender Support</el-link>
                                                </div>
                                                <div class="d-flex align-items-center" style="height: 1.75rem">
                                                    <el-link href="http://zalo.me/+84962868890" target="_blank"
                                                        :underline="false">+(84)
                                                        962-868-890</el-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <img src="/background/support/support-background-2.svg" style="height: 17.5rem"
                                            alt="" />
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                    <div
                        class="ml-0 ml-lg-4 mt-0 mt-lg-5 d-flex flex-row flex-lg-column justify-content-center align-items-center mb-5 chat-history-block">
                        <el-card class="box-card m-auto d-block d-lg-flex flex-column chat-history-box flex-fill w-100 mb-5 mb-md-0"
                            :body-style="{ padding: '0.5rem 0' }" style="max-width: 95vw !important;">
                            <div class="d-flex align-items-center w-100">
                                <div class="flex-fill d-flex align-items-center pl-2"
                                    style="font-size: 1.2rem; color: #42a5f5">
                                    <div v-if="conversationItemSelected !== null">
                                        <el-tooltip :content="$t('support.goBackConversations')" placement="top">
                                            <el-button type="text" class="mr-1 p-0 m-0" @click="backToConversationList">
                                                <i class="el-icon-arrow-left" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </div>
                                    <transition name="fade">
                                        <div v-if="conversationItemSelected === null && !toggleFilterByDate"
                                            class="text-nowrap">
                                            <i class="el-icon-chat-line-round"></i> {{ $t('support.conversations') }}
                                        </div>
                                    </transition>
                                    <transition name="fade">
                                        <div class="d-flex align-items-center" style="font-size: 0.9rem;" v-if="conversationItemSelected !== null">
                                            <i class="el-icon-chat-line-round mr-1"></i><v-clamp autoresize :max-lines="1"> {{ $t('support.conversationPrefix') }}
                                                {{ conversationItemSelected.createdAt | pretyDateUtcToLocal }}</v-clamp>
                                        </div>
                                    </transition>
                                </div>
                                <div class="d-flex align-items-center">
                                    <transition name="slide">
                                        <div class="mr-2"
                                            v-if="conversationItemSelected === null && toggleFilterByDate">
                                            <el-date-picker v-model="dateFilterVal" :range-separator="$t('support.dateRangeTo')" size="mini"
                                                type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                :placeholder="$t('support.pickDate')" @change="refreshConversation">
                                            </el-date-picker>
                                        </div>
                                    </transition>

                                    <div class="pr-1 d-flex align-items-center" style="background-color: #fff;">
                                        <el-tooltip :content="$t('support.filterByDate')" placement="top"
                                            v-if="conversationItemSelected === null && !toggleFilterByDate">
                                            <el-button type="text" class="mr-2 p-0 m-0"
                                                @click="toggleFilterByDate = true">
                                                <i class="el-icon-date" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>

                                        <el-tooltip :content="$t('support.closeFilter')" placement="top"
                                            v-if="conversationItemSelected === null && toggleFilterByDate">
                                            <el-button type="text" class="mr-2 p-0 m-0"
                                                @click="dateFilterVal = null; toggleFilterByDate = false; refreshConversation();">
                                                <i class="el-icon-close text-danger" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>

                                        <el-tooltip :content="$t('support.refresh')" placement="top"
                                            v-if="conversationItemSelected === null">
                                            <el-button type="text" class="mr-2 p-0 m-0" @click="refreshConversation">
                                                <i class="el-icon-refresh" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>

                                        <el-tooltip :content="$t('support.refresh')" placement="top"
                                            v-if="conversationItemSelected !== null">
                                            <el-button type="text" class="mr-2 p-0 m-0" @click="refreshChatHistory">
                                                <i class="el-icon-refresh" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>


                                        <el-tooltip :content="$t('support.goToLastMessage')" placement="top" class="ml-2"
                                            v-if="conversationItemSelected !== null && messageItems.length > 0">
                                            <el-button type="text" class="mr-2 p-0 m-0" @click="scrollToEnd">
                                                <i class="el-icon-bottom" style="font-size: 1.5rem;"></i>
                                            </el-button>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div class="chat-box-content flex-fill position-relative ml-2 mr-2">
                                <div class="position-absolute d-flex flex-column w-100 h-100 animatied-left-position"
                                    :style="`left: ${conversationItemSelected === null ? 0 : -100}%; z-index: ${conversationItemSelected === null ? 'auto' : -1};`"
                                    v-loading="isLoadingConversation">
                                    <VuePerfectScrollbar class="flex-fill w-100 pr-3 mt-2 pr-2 list-group-wrapper"
                                        id="chatScrollerConversation" :settings="{ suppressScrollX: true }"
                                        style="height: 100px;">
                                        <div class="mt-2 ml-2 w-100" v-if="conversationItems.length > 0">
                                            <ul class="list-group">
                                                <li class="list-group-item pl-2 w-100 "
                                                    v-for="conversationItem in conversationItems"
                                                    :key="conversationItem.id"
                                                    :id="`conversationItemId_${conversationItem.id}`">
                                                    <a href="javascript:void();" class="d-block"
                                                        @click="changeConversation(conversationItem)">
                                                        <div class="w-100 d-flex align-items-center">
                                                            <div class="mr-1" style="color: rgb(66, 165, 245);">
                                                                <i class="el-icon-chat-dot-square fa-3x"></i>
                                                            </div>
                                                            <div class="">
                                                                <div>
                                                                    <strong class="text-nowrap"
                                                                        style="color: rgb(66, 165, 245);">
                                                                        Conversation {{ conversationItem.createdAt |
                                                                            pretyDateUtcToLocal }}
                                                                    </strong>
                                                                </div>
                                                                <div style="font-size: 85%;" class="text-muted">
                                                                    <v-clamp autoresize :max-lines="1">{{
                                                                        conversationItem.lastMessage }}</v-clamp>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else
                                            class="d-flex align-items-center justify-content-center flex-fill w-100 mt-5"
                                            style="position: absolute; top: 0; left: 0; height: calc(100% - 10rem); width: 100%;">
                                            <div class="d-block text-center">
                                                <svg style="width: 40%" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M22 10V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H14"
                                                        stroke="#777" stroke-width="1.5" stroke-miterlimit="10"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path opacity="0.4"
                                                        d="M19.5 7C20.8807 7 22 5.88071 22 4.5C22 3.11929 20.8807 2 19.5 2C18.1193 2 17 3.11929 17 4.5C17 5.88071 18.1193 7 19.5 7Z"
                                                        stroke="#292D32" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M15.9965 11H16.0054" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M11.9945 11H12.0035" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M7.99451 11H8.00349" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <div class="text-center text-muted">
                                                    <div>
                                                        <strong>{{ $t('support.noConversation') }}</strong>
                                                    </div>
                                                    <p class="text-muted">{{ $t('support.noConversationDescription') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </VuePerfectScrollbar>
                                </div>
                                <div class="position-absolute d-flex flex-column w-100 h-100 animatied-left-position"
                                    :style="`left: ${conversationItemSelected !== null ? 0 : 100}%;`"
                                    v-loading="isLoading">
                                    <VuePerfectScrollbar class="flex-fill w-100 pr-3 mt-2" id="chatScroller"
                                        :settings="{ suppressScrollX: true }" style="height: 100px;">
                                        <!-- .filter(xItem => xItem.content && xItem.content !== null && xItem.content !== '') -->
                                        <div class="mt-2 ml-2 d-flex flex-column w-100" v-if="messageItems.length > 0">
                                            <div class="d-flex"
                                                v-bind:class="{ 'justify-content-end': isContactMsg(messageItem), 'justify-content-start': !isContactMsg(messageItem) }"
                                                v-for="messageItem in messageItems" :key="messageItem.id"
                                                :id="`messageItemId_${messageItem.id}`">
                                                <div class="bubble"
                                                    v-bind:class="{ 'bubble-right': isContactMsg(messageItem), 'bubble-left': !isContactMsg(messageItem) }">
                                                    <div v-if="messageItem.content">{{ messageItem.content }}</div>
                                                    <div v-else>
                                                        <div class="text-left"><i class="el-icon-paperclip"></i> <i>{{ $t('support.sentAttachment') }}</i></div>
                                                    </div>
                                                    <div class="mt-1"
                                                        style="font-size: 80%; opacity: 0.6; font-style:italic;">
                                                        <i class="el-icon-time"></i> {{ messageItem.createdAt |
                                                            pretyDateUtcToLocal }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else
                                            class="d-flex align-items-center justify-content-center flex-fill w-100 mt-5"
                                            style="position: absolute; top: 0; left: 0; height: calc(100% - 10rem); width: 100%;">
                                            <div class="d-block text-center">
                                                <svg style="width: 40%" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M22 10V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H14"
                                                        stroke="#777" stroke-width="1.5" stroke-miterlimit="10"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path opacity="0.4"
                                                        d="M19.5 7C20.8807 7 22 5.88071 22 4.5C22 3.11929 20.8807 2 19.5 2C18.1193 2 17 3.11929 17 4.5C17 5.88071 18.1193 7 19.5 7Z"
                                                        stroke="#292D32" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M15.9965 11H16.0054" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M11.9945 11H12.0035" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path opacity="0.4" d="M7.99451 11H8.00349" stroke="#292D32"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <div class="text-center text-muted">
                                                    <div>
                                                        <strong>{{ $t('support.noMessage') }}</strong>
                                                    </div>
                                                    <p class="text-muted">{{ $t('support.noMessageDescription') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </VuePerfectScrollbar>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </div>

    </VuePerfectScrollbar>
</template>

<script>
import { mapState } from "vuex";
import VClamp from 'vue-clamp';
import api from '@/api/baseApi';
import { SETTINGS_CHAT_HISTORY_API } from "@/constant/apiSettings";
const queryString = require('query-string');
export default {
    components: {
        VClamp
    },
    data() {
        return {
            EMAIL_SUPPORT: process.env.VUE_APP_EMAIL_SUPPORT,
            quality: 1,
            toggleFilterByDate: false,
            isLoadingConversation: true,
            isInitedConversation: false,
            currentPageConversation: 1,
            dateFilterVal: null,
            conversationItems: [],
            conversationItemSelected: null,

            isLoading: true,
            isInited: false,
            currentPage: 1,
            messageItems: [],
        };
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    mounted() {
        this.getChatConversation("LOAD_MORE");
        //this.getChatHistory("REFRESH");
    },
    beforeDestroy() {
        $("#chatScroller").off("scroll");
        $("#chatScrollerConversation").off("scroll");
    },
    methods: {
        openTawkTo() {
            if (window.chatTool === "tawk.to") window.Tawk_API.maximize();
            if (window.chatTool === "chatwood") window.$chatwoot.toggle("open");
        },
        isContactMsg(messageItem) {
            return messageItem.senderType !== null && messageItem.senderType === 'Contact';
        },
        refreshChatHistory() {
            this.currentPage = 1;
            this.getChatHistory("REFRESH")
        },
        getChatHistory(targetAction = "LOAD_MORE") {
            this.isLoading = true;
            const requestSettings = SETTINGS_CHAT_HISTORY_API.GET_CHAT_HISTORY_BY_CONVERSATION;
            const conversationId = this.conversationItemSelected.id;
            let requestParams = {
                conversationId: conversationId,
                page: this.currentPage,
                pageSize: 50
            };
            api.baseRequest(requestSettings, null, `?${queryString.stringify(requestParams)}`)
                .then((res) => {
                    if (res.data) {
                        if (res.data.length > 0) {
                            let firstId = null;
                            if (this.messageItems.length > 0) firstId = this.messageItems[0].id;
                            switch (targetAction) {
                                case "LOAD_MORE":
                                    this.$set(this, "messageItems", (res.data.reverse()).concat(this.messageItems));
                                    if (firstId !== null) {
                                        this.$nextTick(() => {
                                            $("#chatScroller").scrollTop($(`#messageItemId_${firstId}`).offset().top);
                                        });
                                    }
                                    break;
                                case "REFRESH":
                                    this.$set(this, "messageItems", (res.data.reverse()));
                                    this.$nextTick(() => {
                                        $("#chatScroller").animate({
                                            scrollTop: $("#chatScroller").prop("scrollHeight")
                                        }, 100);
                                        if (!this.isInited) {
                                            this.isInited = true;
                                            $("#chatScroller").on("scroll", () => {
                                                if ($("#chatScroller").scrollTop() === 0) {
                                                    this.loadOlder();
                                                }
                                            });
                                        }
                                    });
                                    break;
                            }
                        }
                        else {
                            if (this.currentPage > 1) this.currentPage = this.currentPage - 1;
                        }
                        this.isLoading = false;
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error(error);
                    this.isLoading = false;
                });
        },
        loadOlder() {
            this.currentPage = this.currentPage + 1;
            this.getChatHistory("LOAD_MORE");
        },
        scrollToEnd() {
            const chatScroller = $("#chatScroller");
            chatScroller.animate({
                scrollTop: chatScroller.prop("scrollHeight")
            }, 100);
        },
        scrollReachStart(evt) {
            // if (!this.isInited) return;
            // console.log(evt);
            // this.loadOlder();
        },
        refreshConversation() {
            this.$set(this, 'conversationItems', []);
            this.$set(this, 'messageItems', []);
            this.currentPageConversation = 1;
            this.getChatConversation("REFRESH")
        },
        getChatConversation(targetAction = "LOAD_MORE") {
            this.isLoadingConversation = true;
            const requestSettings = SETTINGS_CHAT_HISTORY_API.GET_CHAT_CONVERSATION;
            let requestParams = { page: this.currentPageConversation, pageSize: 50 };
            if (this.dateFilterVal && this.dateFilterVal !== '') {
                requestParams.filterDate = this.dateFilterVal;
            }
            api.baseRequest(requestSettings, null, `?${queryString.stringify(requestParams)}`)
                .then((res) => {
                    if (res.data) {
                        if (res.data.length > 0) {
                            switch (targetAction) {
                                case "LOAD_MORE":
                                    this.$set(this, 'conversationItems', (res.data).concat(this.conversationItems).map(xItem => {
                                        return {
                                            ...xItem,
                                            additionalAttributesData: xItem.additionalAttributes ? JSON.parse(xItem.additionalAttributes) : {}
                                        }
                                    }));
                                    break;
                                case "REFRESH":
                                    this.$set(this, 'conversationItems', (res.data.map(xItem => {
                                        return {
                                            ...xItem,
                                            additionalAttributesData: xItem.additionalAttributes ? JSON.parse(xItem.additionalAttributes) : {}
                                        }
                                    })));
                                    this.$nextTick(() => {
                                        if (!this.isInitedConversation) {
                                            this.isInitedConversation = true;
                                            $("#chatScrollerConversation").on("scroll", () => {
                                                let scrollHeight = $("#chatScrollerConversation").prop("scrollHeight");
                                                if ($("#chatScrollerConversation").scrollTop() === scrollHeight) {
                                                    this.loadOlderConversation();
                                                }
                                            });
                                        }
                                    });
                                    break;
                            }
                        }
                        else {
                            if (this.currentPageConversation > 1) this.currentPageConversation = this.currentPageConversation - 1;
                            this.isLoading = false;
                        }
                        this.isLoadingConversation = false;
                    }
                    this.isLoadingConversation = false;
                })
                .catch(error => {
                    console.error(error);
                    this.isLoadingConversation = false;
                });
        },
        loadOlderConversation() {
            this.currentPageConversation = this.currentPageConversation + 1;
            this.getChatConversation("LOAD_MORE");
        },
        backToConversationList() {
            this.$set(this, 'messageItems', []);
            this.conversationItemSelected = null;
            this.currentPage = 1;
            this.refreshConversation();
        },
        changeConversation(conversationItem) {
            $("#chatScroller").off("scroll");
            this.isInited = false;
            this.$set(this, 'messageItems', []);
            this.conversationItemSelected = conversationItem;
            this.currentPage = 1;
            this.getChatHistory("REFRESH");
        },
    },
};
</script>

<style lang="css" scoped>
.chat-history-box::v-deep>.el-card__body {
    display: flex !important;
    flex-direction: column !important;
    flex: 1 1 auto !important;
}

.slide-leave-active,
.slide-enter-active {
    transition: 0.3s;
}

.slide-enter {
    transform: translate(100%, 0);
    opacity: 1;
}

.slide-leave-to {
    transform: translate(100%, 0);
    opacity: 0;
    width: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
    width: 0;
    z-index: -1;
}

.chat-history-box::v-deep .bubble {
    --r: 20px;
    /* the radius */
    --t: 20px;
    /* the size of the tail */
    margin-bottom: 0.8rem;
    max-width: 80%;
    padding: calc(2*var(--r)/3);
    -webkit-mask:
        radial-gradient(var(--t) at var(--_d) 0, #0000 98%, #000 102%) var(--_d) 100%/calc(100% - var(--r)) var(--t) no-repeat,
        conic-gradient(at var(--r) var(--r), #000 75%, #0000 0) calc(var(--r)/-2) calc(var(--r)/-2) padding-box,
        radial-gradient(closest-side at 50% 50%, #000 98%, #0000 101%) 0 0/var(--r) var(--r) space padding-box;
}

.chat-history-box::v-deep .bubble-left {
    --_d: 0%;
    border-left: var(--t) solid #0000;
    margin-right: var(--t);
    place-self: start;
    color: #fff;
    background: linear-gradient(135deg, #42a5f5, #1384C5) border-box;
}

.chat-history-box::v-deep .bubble-right {
    --_d: 100%;
    border-right: var(--t) solid #0000;
    margin-left: var(--t);
    place-self: end;
    color: #000;
    background: linear-gradient(135deg, #bbbbbb, #cecece) border-box;
}

.list-group-wrapper {
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-wrapper .list-group-item {
    border-left: none;
    border-right: none;
}

.list-group-wrapper .list-group-item:first-child {
    border-top: none;
}

.list-group-wrapper .list-group-item:last-child {
    border-bottom: none;
}

.list-group-wrapper .list-group-item:hover {
    background-color: #e5f0ff;
}

.list-group-wrapper .list-group-item a {
    color: inherit;
    text-decoration: none;
}

.animatied-left-position {
    transition: left 0.3s;
    -webkit-transition: left 0.3s;
    -moz-transition: left 0.3s;
}

.chat-history-block {
    width: 100%;
    max-width: 100%;
}


.chat-history-block .el-card {
    max-width: 50rem !important;
}

.chat-history-block .chat-box-content {
    height: 30rem !important;
}

.box-time-notification {
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 5px 10px;
    background: aliceblue;
}

.box-time-zone {
    margin-left: 10px;
}

.box-time-zone-mobile {
    display: none !important;
}

@media only screen and (max-width: 600px) {
  .box-time-zone {
    display: none;
  }

  .box-time-zone-mobile {
    display: inline !important;
  }
}

@media screen and (min-width: 1264px) {
    .chat-history-block {
        width: 30rem;
    }

    .chat-history-block .chat-box-content {
        height: auto !important;
    }
}
</style>